<template>
  <div class="condizioni-generali">
    <div class="default-container default-container-smaller">
      <h1>Cookie Policy</h1>
      <div class="cookiebot-policy-wrap" />
    </div>
  </div>
</template>

<script>
import lang from '@/views/mixins/lang'
import dataLoad from '@/views/mixins/dataLoad'

export default {
  mixins: [ lang, dataLoad ],
  mounted () {
    const externalScript = document.createElement('script')
    const CookiebotId = '61b460a4-3a2f-4d67-8281-8cf183830fcf'
    externalScript.setAttribute(
      'src',
      `https://consent.cookiebot.com/${CookiebotId}/cd.js`
    )
    externalScript.setAttribute('id', 'CookieDeclaration')
    externalScript.setAttribute('data-culture', this.lang)
    const sectionElement = document.querySelector('.cookiebot-policy-wrap')
    sectionElement.appendChild(externalScript)
  }
}
</script>
